import jwtDecode from "jwt-decode";
import { ApiService, IUserData, IUserProfileController, IUserProfileResponse, IUserProfileResponseData } from "../../../../../core";

export class UserProfileControllerImpl implements IUserProfileController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    async getUserProfileData(): Promise<IUserProfileResponseData> {
        try {
            const response: IUserProfileResponse = await this.api.get(`/user-data-profile`);
            if (response.success) {
                const decodedToken: IUserData = jwtDecode(response.response);

                return {
                    "success": true,
                    "response": decodedToken
                };
            }
            return {
                success: false,
            }

        } catch (error) {
            if (error?.response?.status === 401) {
                // eslint-disable-next-line no-throw-literal
                throw ("401");
            } else {
                return error.message;
            }
        }
    }

    async updateUserProfile(formData: FormData): Promise<IUserProfileResponse> {
        try {
            const response: IUserProfileResponse = await this.api.post(`/user-data-profile`, formData);
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                // eslint-disable-next-line no-throw-literal
                throw ("401");
            } else {
                return error.message;
            }
        }
    }
    async getAddressDataByZipcode(zipcode: string): Promise<Array<string>> {
        const sanitizeZipcode = zipcode.replace(/[^\d]+/g, '');
        if (sanitizeZipcode === '' || sanitizeZipcode.length !== 8) { return false }
        try {
            const response = await fetch(`https://viacep.com.br/ws/${sanitizeZipcode}/json/`)
                .then((response) => response.json());
            return response;
        } catch (error) {
            if (error?.response?.status === 401) {
                // eslint-disable-next-line no-throw-literal
                throw ("401");
            } else {
                return error.message;
            }
        }
    }
}